import { useEffect, useState } from "react";
import { useGetReasonsQuery } from "../../app/api/controlApi";

const filterUnique = (options) => {
  return Array.from(new Map(options.map((opt) => [opt.value, opt])).values());
};

// get all reasons modes
export const useReasonOptions = (filter = {}) => {
  const [reasons, setReasons] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMoreOptions, setHasMoreOptions] = useState(true);

  const payload = {
    pageNumber: page,
    pageSize: 1000,
    approvalStatus: filter.approvalStatus,
    search: filter.search,
    module: 17,
  };
  // console.log("payload", payload);
  const { data, isFetching } = useGetReasonsQuery(payload);

  useEffect(() => {
    if (data?.result?.items?.length) {
      setReasons((prev) =>
        filterUnique([
          ...prev,
          ...data.result.items.map((reason) => ({
            value: reason.id,
            label: reason.reason,
          })),
        ])
      );
      setHasMoreOptions(data.result.length === 30);
    } else {
      setHasMoreOptions(false);
    }
  }, [data]);

  const loadMoreOptions = () => {
    if (!isFetching && hasMoreOptions) {
      setPage((prev) => prev + 1);
    }
  };

  return {
    isLoading: isFetching,
    reasons,
    hasMoreOptions,
    loadMoreOptions,
  };
};
